<!-- 页面已废弃 -->
<template>
  <div class="category-select">
    <div class="mask" v-show="showPopup"></div>
    <div :class="{ container: true, filterBlur: showPopup }">
      <div class="model" @click="goHome">
        {{
          current.brand_name
            ? `${current.brand_name} - ${current.factory_name}`
            : ""
        }}<i
          style="margin-left: 6px; color: #333"
          class="iconfont icon-arrowR font-10"
        />
      </div>
      <div class="select" v-if="accessMenus.length > 0">
        <div class="sub-title">常规保养</div>
        <div class="list">
          <div
            class="item"
            v-if="accessMenus.includes(1)"
            @click="clickMenu('engine-oil')"
          >
            <img src="@/assets/maintenance/select-icon1.png" alt="" />
            <span>机油</span>
          </div>
          <div
            v-if="accessMenus.includes(2)"
            class="item"
            @click="clickMenu('transmission-oil')"
          >
            <img src="@/assets/maintenance/select-icon2.png" alt="" />
            <span>变速箱油</span>
          </div>

          <div v-if="false" class="item" @click="clickMenu('air-filter')">
            <img src="@/assets/maintenance/select-icon3.png" alt="" />
            <span>空气滤清器</span>
          </div>
          <div v-if="false" class="item" @click="clickMenu('cabin-filter')">
            <img src="@/assets/maintenance/select-icon4.png" alt="" />
            <span>空调滤清器</span>
          </div>

          <div
            v-if="accessMenus.includes(3)"
            class="item"
            @click="clickMenu('tire')"
          >
            <img src="@/assets/maintenance/select-icon5.png" alt="" /><span
              >轮胎</span
            >
          </div>
          <div
            v-if="accessMenus.includes(4)"
            class="item"
            @click="clickMenu('oil-filter')"
          >
            <img src="@/assets/maintenance/select-icon6.png" alt="" />
            <span>机油滤清器</span>
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <div class="empty-box">
          <img class="empty-img" src="@/assets/maintenance/empty-bg.png" />
          <span>暂无产品推荐～</span>
        </div>
      </div>
    </div>
    <div :class="{ height0: !showPopup, popup: true }">
      <div class="content" v-show="showPopup">
        <div class="title">
          <span class="left">
            <span>{{ popupTitle }}</span>
          </span>
          <i
            class="close iconfont icon-guanbi font-10 color-grayC"
            @click.stop="cancelChoose"
          ></i>
        </div>
        <div class="sub-list">
          <div
            :class="{ subItem: true, multiple: item.multiple }"
            v-for="(item, index) in popupList"
            :key="index"
            @click="itemClickHandler(item)"
          >
            <span v-html="item.text"></span
            ><i class="iconfont icon-arrowR font-10 color-grayC" />
          </div>
        </div>
      </div>
    </div>
    <!-- <fab-button></fab-button> -->
  </div>
</template>
<script>
// import FabButton from "@/components/FabButton.vue";
import api from "@/apis/maintenance-api.js";
import wx from "weixin-js-sdk";
import validToken from "@/mixins/valid-token.js";
export default {
  mixins: [validToken],
  // components: { FabButton },
  data() {
    return {
      showPopup: false,
      args: {},
      multipleEnginesCarsArr: [],
      popupList: [],
      popupTitle: "",
      accessMenus: [], //当前版本可允许访问的菜单 1-机油 2-变速箱油 3-轮胎
      current: "", //从首页传递的当前选择车型数据（部分细分）
      category: -1, //当前点击的分类标识，机油-1，变速箱油-2
    };
  },
  mounted() {
    if (this.browser.wx == 1) {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
    this.initData();
  },
  methods: {
    goHome() {
      this.$router.push({
        path: "/home",
        query: {
          id: this.$route.query.scheme_id,
        },
      });
    },
    // 取消选择
    cancelChoose() {
      this.showPopup = false;
    },
    // 返回
    goBack() {
      this.$router.go(-1);
    },
    initData() {
      this.fetchAccessMenus();
      this.current = this.$route.query;
      const {
        brand_name,
        factory_name,
        model_alias,
        displacement,
        release_year,
        sales_name,
      } = this.current;
      this.args = {
        brand_name,
        factory_name,
        displacement,
        model_alias,
        release_year,
        sales_name,
      };
    },
    fetchAccessMenus() {
      api
        .carBrandList({
          scheme_id: this.$route.query.scheme_id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.accessMenus = res.data.menus.map((i) => i.type);
          }
        });
    },

    // 检查车型备注列表
    async checkModelNotes() {
      await this.fetchValidToken();
      if (!this.token) return;
      const { id, scheme_id, from } = this.current;
      const vehicle_ids = this.current.id ? [this.current.id] : [];
      const params = {
        ...this.args,
        parts_type: 1,
        token: this.token,
        vehicle_ids,
        scheme_id,
      };
      const res = await api.getModelDetail(params);
      if (res.code === 0) {
        let memo_list = res.data.vehicle_list.filter((i) => i.id == id)[0]
          .memo_list;
        if (memo_list.length > 0) {
          memo_list.forEach((i) => (i.text = i.memo_val));
          this.popupList = memo_list;
          this.popupTitle = "车型备注";
          this.showPopup = true;
        } else {
          this.$router.push({
            path: "/detail",
            query: {
              menu: 1,
              levelId: id,
              value: 1,
              scheme_id,
              isVin: from === "vin" ? "1" : "",
              internal_from: this.$route.query.internal_from,
            },
          });
        }
      } else {
        this.$toast.show({
          showTime: 3,
          message: res.message,
          style: "error",
        });
      }
      console.log(id, res.data.vehicle_list);
    },
    // 检查是否有发动机列表/是否有车型备注/都没有直接跳转
    async checkEngineList() {
      await this.fetchValidToken();
      if (!this.token) return;
      const { scheme_id } = this.current;
      const params = {
        ...this.args,
        parts_type: 1,
        token: this.token,
        scheme_id,
      };
      const res = await api.getModelDetail(params);
      if (res.code === 0) {
        if (res.data.engine_models.length >= 2) {
          let enginesListTemp = res.data.engine_models;
          enginesListTemp.forEach((i) => (i.text = i.engine_model));
          this.multipleEnginesCarsArr = res.data.vehicle_list;
          this.popupList = enginesListTemp;
          this.popupTitle = "发动机";
          this.showPopup = true;
        } else {
          if (res.data.vehicle_list[0].memo_list.length > 0) {
            this.popupList = res.data.vehicle_list[0].memo_list;
            this.popupList.forEach((i) => (i.text = i.memo_val));
            this.popupTitle = "车型备注";
            this.showPopup = true;
          } else {
            this.$router.push({
              path: "/detail",
              query: {
                menu: 1,
                levelId: res.data.vehicle_list[0].id,
                value: 1,
                scheme_id,
                internal_from: this.$route.query.internal_from,
              },
            });
          }
        }
      } else {
        this.$toast.show({
          showTime: 3,
          message: res.message,
          style: "error",
        });
      }
    },

    // 点击不同汽车配件
    async clickMenu(routeName) {
      await this.fetchValidToken();
      if (!this.token) return;
      if (routeName === "engine-oil") {
        this.category = 1;
        this.checkEngineOil(); //检查机油子分类的逻辑
      } else if (routeName === "transmission-oil") {
        this.category = 2;
        this.checkTransmissionOil(); //检查变速箱油子分类的逻辑
      } else if (routeName === "tire") {
        this.category = 3;
        this.checkTireCategory(); //检查轮胎子分类的逻辑
      } else if (routeName === "oil-filter") {
        this.category = 4;
        this.checkOilFilterCategory(); //检查机油滤清器子分类的逻辑
      } else {
        this.$toast.show({
          showTime: 3,
          message: "此保养分类暂未开放",
          style: "error",
        });
      }
    },
    // 检查机油- 汽车子分类
    async checkEngineOil() {
      // selectYear-选择年份 // vinCarList-vin识别车型列表
      if (this.$route.query.from === "select") {
        // 检查发动机列表有或没有时检查车型备注
        this.checkEngineList();
      } else if (this.$route.query.from === "vin") {
        // 检查车型备注并弹出或跳转详情
        this.checkModelNotes();
      }
    },
    // 检查变速箱油- 汽车子分类
    async checkTransmissionOil() {
      await this.fetchValidToken();
      if (!this.token) return;
      let vehicle_ids = this.current.id ? [this.current.id] : [];
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        ...this.args,
        parts_type: 2,
        vehicle_ids,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          // res.data = mockcheckTireCategory;
          if (res.data.parts_list.length > 1) {
            res.data.parts_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.parts_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            this.popupTitle = "额外选项";
            this.popupList = tempChoices;
            this.showPopup = true;
            // 没有直接跳转
          } else {
            this.$router.push({
              path: "/detail",
              query: {
                menu: 2,
                id: this.$route.query.from == "vin" ? this.$route.query.id : "",
                key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
                ...this.args,
                scheme_id: this.$route.query.scheme_id || "",
                internal_from: this.$route.query.internal_from,
              },
            });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },

    itemClickHandler(item) {
      const { scheme_id } = this.current;
      // 点击机油-发动机、点击机油-车型备注、点击箱油-额外选项、点击轮胎-额外选项
      // 机油-车型备注
      if (item.memo_val) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 1,
            levelId: item.vehicle_id,
            value: item.type,
            isVin: this.$route.query.from == "vin" ? 1 : "",
            scheme_id,
            internal_from: this.$route.query.internal_from,
          },
        });
        return;
      }
      // 机油-发动机
      if (item.engine_model) {
        let car = this.multipleEnginesCarsArr.find(
          (i) => i.engine_model === item.engine_model
        );
        // mock
        // car.memo_list = [
        //   {
        //     type: 1,
        //     memo_id: 4250,
        //     memo_val: "机油盖无标识",
        //     oil_grade: "5W-40",
        //     vehicle_id: 193435,
        //   },
        //   {
        //     type: 2,
        //     memo_id: 4249,
        //     memo_val: "机油盖有标识0W-20",
        //     oil_grade: "0W-20",
        //     vehicle_id: 193435,
        //   },
        // ];
        if (car.memo_list.length > 0) {
          car.memo_list.forEach((i) => (i.text = i.memo_val));
          this.popupList = car.memo_list;
          this.popupTitle = "车型备注";
          this.showPopup = true;
        } else {
          this.$router.push({
            path: "/detail",
            query: {
              menu: 1,
              levelId: item.vehicle_id,
              value: 1,
              scheme_id,
              internal_from: this.$route.query.internal_from,
            },
          });
        }
        return;
      }
      // 点击箱油-额外选项
      if (this.category === 2) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 2,
            id: this.$route.query.from == "vin" ? this.$route.query.id : "",
            key: item.key,
            ...this.args,
            scheme_id,
            internal_from: this.$route.query.internal_from,
          },
        });
        return;
      }
      // 点击轮胎-额外选项
      if (this.category === 3) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 3,
            id: this.$route.query.from == "vin" ? this.$route.query.id : "",
            key: item.key,
            ...this.args,
            scheme_id,
            internal_from: this.$route.query.internal_from,
          },
        });
        return;
      }
      // 点击机油滤清器-车型备注
      if (this.category === 4) {
        this.$router.push({
          path: "/detail",
          query: {
            menu: 4,
            key: item.key,
            ...this.args,
            scheme_id: this.$route.query.scheme_id,
            internal_from: this.$route.query.internal_from,
          },
        });
        return;
      }
    },
    async checkTireCategory() {
      await this.fetchValidToken();
      if (!this.token) return;
      let vehicle_ids = this.current.id ? [this.current.id] : [];
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        ...this.args,
        parts_type: 3,
        vehicle_ids,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        let res = await api.getModelDetail(params);
        // res.data = mockcheckTireCategory;
        if (res.code === 0) {
          if (res.data.parts_list.length > 1) {
            res.data.parts_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.parts_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            this.popupTitle = "额外选项";
            this.popupList = tempChoices;
            this.showPopup = true;
            // 没有直接跳转
          } else {
            this.$router.push({
              path: "/detail",
              query: {
                menu: 3,
                id: this.$route.query.from == "vin" ? this.$route.query.id : "",
                key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
                ...this.args,
                scheme_id: this.$route.query.scheme_id || "",
                internal_from: this.$route.query.internal_from,
              },
            });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    async checkOilFilterCategory() {
      await this.fetchValidToken();
      if (!this.token) return;
      let vehicle_ids = this.current.id ? [this.current.id] : [];
      // 获取滤清器备注
      this.$loading.show("加载中...");
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      try {
        const params = {
          ...this.args,
          parts_type: 4,
          vehicle_ids,
          token: this.token,
          scheme_id,
        };
        const res = await api.getModelDetail(params);
        if (res.code === 0) {
          if (res.data.parts_list.length > 1) {
            let tempChoices = res.data.parts_list.map((i) => {
              i.text = i.choices[0].value;
              return i;
            });
            this.popupTitle = "车型备注";
            this.popupList = tempChoices;
            this.showPopup = true;
          } else if (res.data.parts_list.length === 1) {
            this.$router.push({
              path: "/detail",
              query: {
                menu: 4,
                key: res.data.parts_list[0].key,
                ...this.args,
                scheme_id: this.$route.query.scheme_id,
                id: this.$route.query.id ? this.$route.query.id : "",
                internal_from: this.$route.query.internal_from,
              },
            });
          } else if (res.data.parts_list.length === 0) {
            this.$loading.hide();
            this.$router.push({
              path: "/detail",
              query: {
                menu: 4,
                key: "",
                ...this.args,
                scheme_id: this.$route.query.scheme_id,
                id: this.$route.query.id ? this.$route.query.id : "",
                internal_from: this.$route.query.internal_from,
              },
            });
            // this.$loading.hide();
            // this.$toast.show({
            //   showTime: 3,
            //   message: "当前车型暂无机油滤清器数据！",
            //   style: "error",
            // });
            // return;
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log("获取滤清器备注信息失败", error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
  },
};
</script>
<style lang="less" scoped>
.fontRed {
  color: #c72d2d;
}
.category-select {
  padding: 0 15/100rem;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  height: 100vh;
  .model {
    font-size: 27/100rem;
    margin-top: 17px;
    margin-bottom: 17px;
    color: #404040;
  }
  .mask {
    position: absolute;
    top: 0;
    height: 100%;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3;
  }
  .select {
    width: 100%;
    height: 616/100rem;
    border-radius: 9/100rem;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.05);
    .sub-title {
      text-indent: 30/100rem;
      line-height: 53/100rem;
      margin-top: 26/100rem;
      margin-bottom: 24/100rem;
      font-size: 27/100rem;
      color: #fff;
      height: 53/100rem;
      background: url("../../assets/maintenance/select-subtitle-bg.png")
        no-repeat left center;
      background-size: contain;
    }
    .list {
      display: flex;
      padding: 0 5/100rem;
      flex-wrap: wrap;
      .item {
        width: auto;
        height: 224/100rem;
        margin-left: 7/100rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 32/100rem;
        img {
          width: 189/100rem;
          height: 189/100rem;
        }
        span {
          font-size: 24/100rem;
          color: #404040;
        }
      }
    }
  }
  .empty {
    margin-top: 100/100rem;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .empty-box {
      display: flex;
      flex-direction: column;
      img {
        width: 157/100rem;
        height: 157/100rem;
      }
      span {
        margin-top: 12/100rem;
        color: #7f7f7f;
        font-size: 27/100rem;
        margin-bottom: 20/100rem;
      }
    }
  }
}
.popup {
  width: 100%;
  height: 539/100rem;
  background-color: #fff;
  transition: 0.3s;
  position: fixed;
  left: 0;
  bottom: 0;
  font-size: 14px;
  z-index: 99;
  padding: 0 26/100rem;
  .content {
    overflow: auto;
    .title {
      line-height: 92/100rem;
      height: 92/100rem;
      color: #c6c6c6;
      border-bottom: 2/100rem #f6f6f6 solid;
      display: flex;
      justify-content: space-between;
      font-size: 24/100rem;
      .left {
        i {
          margin-right: 17/100rem;
        }
        span {
          i {
            margin: 0 6/100rem;
          }
        }
      }
    }
    .sub-list {
      overflow: auto;
      height: 448/100rem;
      .subItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 40/100rem;
        // padding: 20/100rem 0;
        font-size: 26/100rem;
        min-height: 87/100rem;
        color: #404040;
        border-bottom: 2px #f6f6f6 solid;
      }
      .multiple {
        padding: 20/100rem 0;
      }
    }
  }
}
.height0 {
  height: 0;
}
.filterBlur {
  -webkit-filter: blur(10/100rem);
  filter: blur(10/100rem);
}
</style>
